<div fxLayout="column">
  <div fxLayout="row" style="font-size: 20px">
    Are you sure you want to continue?
  </div>
  <div fxLayout="row" class="body1" style="margin-top: 20px">
    Once saved the country configuration cannot be changed.
  </div>
  <div class="button-container" style="margin-top: 20px">
    <button
      mat-button
      (click)="confirm()"
      color="accent"
      class="example-button-row"
      type="button"
    >
      CONFIRM
    </button>
    <button
      mat-button
      (click)="cancel()"
      class="example-button-row"
      class="button-style"
    >
      CANCEL
    </button>
  </div>
</div>
